import { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { Zap, Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";
import { formatApiError } from "@/api";

export default function AdminLogin() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm bg-[#0F172A] border border-amber-500/20 p-8">
        <div className="flex items-center gap-2 mb-8">
          <span className="w-8 h-8 bg-amber-500 flex items-center justify-center">
            <Zap className="w-5 h-5 text-slate-950" strokeWidth={2.5} />
          </span>
          <span className="font-condensed font-extrabold uppercase tracking-wide text-lg">
            Owner <span className="text-amber-500">Login</span>
          </span>
        </div>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-xs font-mono-brand uppercase tracking-[0.2em] text-slate-400 mb-2">Username</label>
            <input type="text" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" placeholder="Your username"
                   className="w-full bg-[#0B0F17] border border-slate-700 focus:border-amber-500 outline-none px-4 py-3 text-slate-100 transition-colors" />
          </div>
          <div>
            <label className="block text-xs font-mono-brand uppercase tracking-[0.2em] text-slate-400 mb-2">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input"
                   className="w-full bg-[#0B0F17] border border-slate-700 focus:border-amber-500 outline-none px-4 py-3 text-slate-100 transition-colors" />
          </div>
          {error && <p className="text-sm text-rose-400" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={busy} data-testid="admin-login-button"
                  className="w-full bg-amber-500 hover:bg-amber-600 disabled:opacity-60 text-slate-950 font-condensed font-bold uppercase tracking-wide py-3 transition-colors flex items-center justify-center gap-2">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />}
            {busy ? "Signing In…" : "Sign In"}
          </button>
        </form>
        <Link to="/" data-testid="admin-back-home" className="mt-6 inline-flex items-center gap-2 text-xs text-slate-500 hover:text-amber-400 transition-colors">
          <ArrowLeft className="w-3.5 h-3.5" /> Back to site
        </Link>
      </div>
    </div>
  );
}
